import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => {
  return {
    dataNotFoundContainer: {
      paddingBottom: "32px",
      maxWidth: "480px",
      width: "100%",
    },
    addTopButton: {
      zIndex: "1",
      position: "absolute",
      right: "32px",
      top: "104px",
    },
    secondaryTitle: {
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "28px",
    },
    capacityFieldsContainer: {
      display: "flex",
      gap: "16px",
      flexDirection: "column",
      width: "100%",
    },
    dialogWrapper: {
      width: "688px",
    },
    deleteDialogWrapper: {
      width: "544px",
      "& button + button": {
        background: theme.palette.error.primary,
      },
    },
    wrapperContainer: {
      display: "flex",
      paddingTop: "16px",
      marginTop: "16px",
      borderTop: "1px solid #EAECF0",
      gap: "32px",
      [theme.breakpoints.down("1280")]: {
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "12px",
      },
    },
    stepperActionContainer: {
      display: "flex",
      justifyContent: "space-between",
      [theme.breakpoints.down("1450")]: {
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "12px",
      },

      [theme.breakpoints.down("420")]: {
        "& div + div": {
          flexDirection: "row",
          flexWrap: "wrap",
        },
        "& div + div > button": {
          order: "3",
        },
        "& div + div > button + button": {
          order: "2",
        },
        "& div + div  button:last-child": {
          order: "3",
        },
      },
    },
    contentWrapper: {
      marginTop: "24px",
      width: "100%",
    },
    settingsForm: {
      padding: "24px 32px",
      [theme.breakpoints.down("600")]: {
        padding: "24px 16px",
      },
    },
    radioGroupLabel: {
      color: "#344054",
      fontSize: "14px",
      minWidth: "280px",
      fontWeight: "600",
      lineHeight: "20px",
      [theme.breakpoints.down("900")]: {
        minWidth: "initial",
      },
    },
    fieldWrapper: {
      gap: "32px",
      alignItems: "flex-start",
      "& + &": {
        borderTop: "1px solid #EAECF0",
        paddingTop: "20px",
        marginTop: "20px",
      },
      [theme.breakpoints.down("900")]: {
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "12px",
      },
    },
    fieldContainer: {
      display: "flex",
      gap: "10px",
      flexDirection: "column",
      width: "100% !important",
      maxWidth: "512px",
    },
    scoreWrapper: {
      flexDirection: "column",
      gap: "16px",
    },
    scoreContainer: {
      display: "flex",
      gap: "10px",
      width: "100% !important",
      maxWidth: "512px",
      [theme.breakpoints.down("1278")]: {
        flexDirection: "column",
      },
    },
    subText: {
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      marginTop: "16px",
      color: theme.palette.text.tertiary,
    },
    secondaryTitle: {
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "28px",
    },
    radioRootWrapper: {
      margin: 0,
    },
    disabled: {
      "&  .MuiInputBase-root": {
        background: "#F9FAFB",
      },
    },
    inputwrapper: {
      width: "100% !important",
      "& label": {
        minWidth: "140px !important",
        width: "auto !important",
      },
      [theme.breakpoints.down("1450")]: {
        gap: "12px",
      },
    },
    capacityLabel: {
      fontSize: "14px",
      fontWeight: "600",
      minWidth: "100px",
      color: "#344054",
    },
    modalIcon: {
      display: "flex",
      alignItems: "center",
      borderRadius: "50%",
      maxWidth: "48px",
      width: "100%",
      height: "48px",
      background: "#FEE4E2",
      justifyContent: "center",
      marginRight: "16px",
    },
  };
});
